<script lang="ts">
    import { CARD_BACKS } from "./lib/content";
    import cardBackColors from "./lib/card_back_colors.json";

    export let variant: number | string = 0;

    // Backward compatibility: if variant is number, map to ID
    $: id =
        typeof variant === "number"
            ? CARD_BACKS[variant]?.id || CARD_BACKS[0].id
            : variant;
    $: def = CARD_BACKS.find((b) => b.id === id) || CARD_BACKS[0];

    $: borderColor = (cardBackColors as Record<string, string>)[id] || "white";
</script>

{#if def.type === "css"}
    <div class="card-back-design {def.value}">
        <div class="pattern"></div>
    </div>
{:else}
    <div class="card-back-design" style="border-color: {borderColor}">
        <img
            src={def.value}
            alt={def.name}
            class="card-back-image"
            draggable="false"
        />
    </div>
{/if}

<style>
    .card-back-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        pointer-events: none;
    }

    .card-back-design {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        border: 2px solid white;
    }

    .pattern {
        width: 100%;
        height: 100%;
    }

    /* Variant 0: Classic Royal Blue */
    .variant-0 {
        background-color: #2b5c8a;
        background-image: radial-gradient(
            circle at center,
            #3a7bd5 0%,
            #2b5c8a 100%
        );
    }
    .variant-0 .pattern {
        background-image: repeating-linear-gradient(
                45deg,
                rgba(255, 255, 255, 0.1) 0px,
                rgba(255, 255, 255, 0.1) 2px,
                transparent 2px,
                transparent 8px
            ),
            repeating-linear-gradient(
                -45deg,
                rgba(255, 255, 255, 0.1) 0px,
                rgba(255, 255, 255, 0.1) 2px,
                transparent 2px,
                transparent 8px
            );
        background-size: 20px 20px;
        border: 4px solid white;
        box-sizing: border-box;
        margin: 4px;
        width: calc(100% - 8px);
        height: calc(100% - 8px);
        border-radius: 4px;
    }

    /* Variant 1: Classic Red Diamonds */
    .variant-1 {
        background-color: #8b0000;
    }
    .variant-1 .pattern {
        background-image: radial-gradient(#ffcccc 15%, transparent 16%);
        background-size: 16px 16px;
    }

    /* Variant 3: Sunset Gradient */
    .variant-3 {
        background: linear-gradient(
            135deg,
            #ff9a9e 0%,
            #fecfef 99%,
            #fecfef 100%
        );
    }
    .variant-3 .pattern {
        background-image: linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.2) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0.2) 75%,
            transparent 75%,
            transparent
        );
        background-size: 20px 20px;
    }
</style>
